var map = {
	"./generic-bg--1.jpg": 2061,
	"./generic-bg--10.jpg": 2062,
	"./generic-bg--2.jpg": 2063,
	"./generic-bg--3.jpg": 2064,
	"./generic-bg--4.jpg": 2065,
	"./generic-bg--5.jpg": 2066,
	"./generic-bg--6.jpg": 2067,
	"./generic-bg--7.jpg": 2068,
	"./generic-bg--8.jpg": 2069,
	"./generic-bg--9.jpg": 2070
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2060;